"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemplateSelector = void 0;
exports.templateSelectionMessage = templateSelectionMessage;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _dialog = require("@design/ui/dialog");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var REASON_CLASS = "m-0 text-body-sm text-foreground-muted";
function templateSelectionMessage(template) {
  return template.template_code ? "I want to use the template \"".concat(template.name, "\" (").concat(template.template_code, ")") : "I want to use the template \"".concat(template.name, "\"");
}
var DATE_KEYS = new Set(["effective_from", "effective_to", "created_date", "modified_date"]);
var formatDate = function formatDate(value) {
  var date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  var hasTime = date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0;
  return date.toLocaleDateString(undefined, _objectSpread({
    year: "numeric",
    month: "short",
    day: "numeric"
  }, hasTime ? {
    hour: "numeric",
    minute: "2-digit"
  } : {}));
};
var formatValue = function formatValue(value, key) {
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (DATE_KEYS.has(key) && typeof value === "string") return formatDate(value);
  return String(value);
};
var detailFields = [{
  label: "Contract type",
  key: "contract_type_name"
}, {
  label: "Code",
  key: "template_code"
}, {
  label: "Status",
  key: "status"
}, {
  label: "Current version",
  key: "is_current_version"
}, {
  label: "Version",
  key: "entity_version"
}, {
  label: "Effective from",
  key: "effective_from"
}, {
  label: "Effective to",
  key: "effective_to"
}, {
  label: "Language",
  key: "language_locale"
}, {
  label: "Date format",
  key: "date_format"
}, {
  label: "Time format",
  key: "time_format"
}, {
  label: "Bilingual",
  key: "is_bilingual_template"
}, {
  label: "Secondary language",
  key: "secondary_language_locale"
}, {
  label: "Secondary date format",
  key: "secondary_language_date_format"
}, {
  label: "Secondary time format",
  key: "secondary_language_time_format"
}, {
  label: "Primary template",
  key: "primary_template_name"
}, {
  label: "Primary template code",
  key: "primary_template_code"
}, {
  label: "Primary template language",
  key: "primary_template_language"
}, {
  label: "Primary template status",
  key: "primary_template_status"
}, {
  label: "Version comments",
  key: "version_comments"
}, {
  label: "Created by",
  key: "created_by"
}, {
  label: "Created",
  key: "created_date"
}, {
  label: "Modified by",
  key: "modified_by"
}, {
  label: "Modified",
  key: "modified_date"
}];
var TemplateDetailModal = function TemplateDetailModal(_ref) {
  var template = _ref.template,
    onClose = _ref.onClose,
    onSelect = _ref.onSelect,
    disabled = _ref.disabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: true,
    onOpenChange: onClose,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "TemplateDetailModal",
    "data-sentry-source-file": "TemplateSelector.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, _objectSpread(_objectSpread({}, template.description ? {} : {
      "aria-describedby": undefined
    }), {}, {
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "TemplateSelector.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "TemplateSelector.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "TemplateSelector.tsx",
          children: template.name
        }), template.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogDescription, {
          children: template.description
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: detailFields.map(function (_ref2) {
          var label = _ref2.label,
            key = _ref2.key;
          var value = template[key];
          if (value === null || value === undefined || value === "") return null;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex gap-3 border-t border-border-subtle py-1.5 text-caption",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "flex-none basis-2/5 text-foreground-muted",
              children: label
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "flex-1 break-words text-foreground-primary",
              children: formatValue(value, key)
            })]
          }, key);
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogFooter, {
        "data-sentry-element": "DialogFooter",
        "data-sentry-source-file": "TemplateSelector.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
          type: "button",
          onClick: onSelect,
          disabled: disabled,
          "data-sentry-element": "Button",
          "data-sentry-source-file": "TemplateSelector.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
            "data-icon": "inline-start",
            "data-sentry-element": "CheckIcon",
            "data-sentry-source-file": "TemplateSelector.tsx"
          }), "Use this template"]
        })
      })]
    }))
  });
};
var TemplateSelector = exports.TemplateSelector = function TemplateSelector(_ref3) {
  var templates = _ref3.templates,
    reason = _ref3.reason,
    sendMessage = _ref3.sendMessage;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedId = _useState2[0],
    setSelectedId = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    detailTemplate = _useState4[0],
    setDetailTemplate = _useState4[1];
  var selecting = selectedId !== null;
  var handleSelect = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(template) {
      var sent, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!selecting) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setSelectedId(template.sys_id);
            setDetailTemplate(null);
            _context.p = 2;
            _context.n = 3;
            return sendMessage(templateSelectionMessage(template));
          case 3:
            sent = _context.v;
            if (!sent) setSelectedId(null);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setSelectedId(null);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function handleSelect(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    size: "sm",
    className: "my-2",
    "data-sentry-element": "Card",
    "data-sentry-component": "TemplateSelector",
    "data-sentry-source-file": "TemplateSelector.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "TemplateSelector.tsx",
      children: [reason ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: REASON_CLASS,
        children: reason
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-2",
        children: templates.map(function (template) {
          var isSelected = selectedId === template.sys_id;
          var meta = [template.template_code, template.status].filter(Boolean).join(" · ");
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: (0, _utils.cn)("flex flex-col gap-2 rounded-md border border-border-default bg-background-card p-3", isSelected && "border-custom-border-primary-checked ring-1 ring-custom-border-primary-checked"),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "flex items-start gap-2.5",
              children: [isSelected ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
                className: "text-foreground-primary"
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DescriptionIcon, {
                className: "text-foreground-muted"
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                className: "flex min-w-0 flex-1 flex-col gap-0.5",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "text-body-sm font-semibold text-foreground-primary",
                  children: template.name
                }), meta ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "text-caption text-foreground-muted",
                  children: meta
                }) : null, template.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "line-clamp-2 text-caption text-foreground-muted",
                  children: template.description
                }) : null]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "flex gap-2",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
                type: "button",
                size: "sm",
                onClick: function onClick() {
                  return handleSelect(template);
                },
                disabled: selecting,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
                  "data-icon": "inline-start"
                }), "Use template"]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
                type: "button",
                variant: "outline",
                size: "sm",
                onClick: function onClick() {
                  return setDetailTemplate(template);
                },
                children: "See more"
              })]
            })]
          }, template.sys_id);
        })
      })]
    }), detailTemplate ? /*#__PURE__*/(0, _jsxRuntime.jsx)(TemplateDetailModal, {
      template: detailTemplate,
      onClose: function onClose() {
        return setDetailTemplate(null);
      },
      onSelect: function onSelect() {
        return handleSelect(detailTemplate);
      },
      disabled: selecting
    }) : null]
  });
};